// extracted by mini-css-extract-plugin
export default {"clickable":"movieDetailsClickableArea__clickable___kAa_","widget":"movieDetailsClickableArea__widget__KSo8l","homeEnt":"movieDetailsClickableArea__homeEnt__Ir4Bc"};